<div class="content">
  <article>
    <app-loading *ngIf="!dedupeState; else loaded"></app-loading>
    <span *ngIf="!dedupeState" class="dashboard-loading">Loading {{ entity }} data...</span>
    <ng-template #loaded>
      <h2 class="heading-underline">
        <span>
        {{ utilsService.getEntityLabel(entity) }}: {{ pageTitle(dedupeState.seedState) }}
        </span>
        <span class="sub-info">Last Sync:
          <span [ngClass]="recentSyncClass ? 'green' : 'red'"> {{ timeAgo }}</span>
          <span *ngIf="showDate" class="sub-info-date"> ({{ dedupeState.lastRun | date }})</span>
        </span>
      </h2>
      <table class="table no-mar-b">
        <tr class="sync-progress" *ngIf="isRunning(dedupeState.seedState) || isComplete(dedupeState.seedState)">
          <td colspan="2">
            <h3 *ngIf="isNotComplete(dedupeState.seedState)">
              <span class="green" *ngIf="runningScript">{{ syncProcessText }}</span>
              <span class="red" *ngIf="totalRecords == 0 && !runningScript">Syncing...</span>
              <span *ngIf="totalRecords != 0 && !runningScript">
                <span class="green">{{ syncProgress.processed }}</span> / <span class="green">{{ syncProgress.totalThisRun }}</span> <span> records {{ syncText(syncProgress.syncStage) }}...</span>
              </span>
            </h3>
            <h3 *ngIf="isComplete(dedupeState.seedState)">
              <span>Synced </span> <span class="hero-text green">{{ syncProgress.totalInDB }}</span> <span> records</span>
            </h3>
            <h3 *ngIf="duplikitMergeService.entityIsMerging(entity)">
              <span class="red">Merging...</span>
            </h3>
            <div class="set-size charts-container">
              <div class="pie-wrapper progress-{{ percentSoFar }}">
                <span class="label">{{ percentSoFar }}<span class="smaller">%</span></span>
                <div class="pie">
                  <div class="left-side half-circle"></div>
                  <div class="right-side half-circle"></div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr class="stats" *ngIf="!isNotComplete(dedupeState.seedState) || isNotComplete(dedupeState.seedState)">
          <td id="noOfRecords">
            <p class="green">{{ syncProgress.totalInDB }}</p>
            <h2>{{ this.utilsService.getPluralEntity(entity) }} in database</h2>
          </td>
          <td id="duplications">
            <i *ngIf="entity == 'Candidate'" class="tooltip-icon bhi-question"
               [matTooltip]="'Any changes to Candidates in Bullhorn may take up to 24 hours to be reflected here'"></i>
            <p [ngClass]="{
                'green': isNotComplete(dedupeState.seedState),
                'red': isComplete(dedupeState.seedState)
            }"> {{ duplicateCount }} </p>
            <h2>Duplicates to merge</h2>
          </td>
        </tr>
      </table>
      <section class="footer-btns stretch-btns">
        <button
                [disabled]="isRunning(dedupeState.seedState) || duplikitMergeService.entityIsMerging() || duplikitSyncService.entityIsSyncing()"
                [ngClass]="{'syncing': isRunning(dedupeState.seedState) }"
                (click)="sync()" theme="nav"
                appRipple>
          <i class="bhi-refresh-o"></i> {{ syncLabel(dedupeState.seedState) }}
        </button>

        <button [hidden]="isNotComplete(dedupeState.seedState)"
                (click)="router.navigate([reportLink])"
                [disabled]="!canMerge()"
                theme="nav" appRipple><i class="bhi-fasterfind"></i>
          Review duplicates
        </button>
      </section>
    </ng-template>
  </article>
</div>
